export var AdditionalAuthorizationType;
(function (AdditionalAuthorizationType) {
    AdditionalAuthorizationType["auth0"] = "auth0";
    AdditionalAuthorizationType["email"] = "email";
    AdditionalAuthorizationType["sms"] = "sms";
})(AdditionalAuthorizationType || (AdditionalAuthorizationType = {}));
export var AuthStep;
(function (AuthStep) {
    AuthStep["None"] = "none";
    AuthStep["Email"] = "email";
    AuthStep["Phone"] = "phone";
    AuthStep["Code"] = "code";
    AuthStep["Verify"] = "verify";
})(AuthStep || (AuthStep = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXV0aC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kb21haW4vYXV0aC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFzQkEsTUFBTSxDQUFOLElBQVksMkJBSVg7QUFKRCxXQUFZLDJCQUEyQjtJQUNyQyw4Q0FBZSxDQUFBO0lBQ2YsOENBQWUsQ0FBQTtJQUNmLDBDQUFXLENBQUE7QUFDYixDQUFDLEVBSlcsMkJBQTJCLEtBQTNCLDJCQUEyQixRQUl0QztBQUVELE1BQU0sQ0FBTixJQUFZLFFBTVg7QUFORCxXQUFZLFFBQVE7SUFDbEIseUJBQWEsQ0FBQTtJQUNiLDJCQUFlLENBQUE7SUFDZiwyQkFBZSxDQUFBO0lBQ2YseUJBQWEsQ0FBQTtJQUNiLDZCQUFpQixDQUFBO0FBQ25CLENBQUMsRUFOVyxRQUFRLEtBQVIsUUFBUSxRQU1uQiJ9